module.exports = __webpack_public_path__ + "img/Natori2.b999455b.png";